import { StdResponse, coreAxios } from "../axios";


/**
 * 添加图层
 * @param projectUuid 
 * @param data 
 * @param params 
 * @returns 
 */
export function addLayer(projectUuid: string, data: any, params?: {}): Promise<StdResponse<any>> {
    return coreAxios.post(`/projects/${projectUuid}/layers`, data, {
        params: {
            ...params,
        }
    })
}

/**
 * 获取图层列表
 * @param projectUuid 
 * @param params 
 * @returns 
 */
export function findLayersInProjectUuid(projectUuid: string, params?: {}): Promise<StdResponse<any>> {
    return coreAxios.get(`/projects/${projectUuid}/layers`, {
        params: {
            ...params,
        }
    })
}

/**
 * 删除图层
 * @param layerUuid 
 * @param params 
 * @returns 
 */
export function deleteLayer(layerUuid: string, params?: {}): Promise<StdResponse<any>> {
    return coreAxios.delete(`/layers/${layerUuid}`, {
        params: {
            ...params,
        }
    })
}

/**
 * 更新图层
 * @param data 
 * @param params 
 * @returns 
 */
export function updateLayer(projectUuid: string, data: any, params?: {}): Promise<StdResponse<any>> {
    return coreAxios.put(`/projects/${projectUuid}/layers`, data, {
        params: {
            ...params,
        }
    })
}
